<template>
  <div id="viewOrder" v-if="data">
    <div class="wait" v-if="data.status==0&&data.pay_type == '在线支付'">
      <el-row style="padding: 20px 0;">
        <el-col :span="4" class="lv3Text" style="text-align:center">
          <div>
            <i class="far fa-clock fa-5x"></i>
          </div>
          <div style="margin-top: 10px;">等待付款</div>
        </el-col>
        <el-col :span="4" class="lv3Text t2">
          <div>
            <div>订单编号</div>
            <div>{{data.orderCode}}</div>
          </div>
        </el-col>
        <el-col :span="4" class="lv3Text t2">
          <div>
            <div>下单时间</div>
            <div>{{dayjs.unix(data.create_time).format('YYYY-MM-DD HH:MM:ss')}}</div>
          </div>
        </el-col>
        <el-col :span="4" class="lv3Text t2">
          <div>
            <div>付款截止时间</div>
            <div>剩余 {{hours+':'+minutes+":"+seconds}}</div>
          </div>
        </el-col>
        <el-col :span="4" class="t3">
          <el-button type="primary" @click="goPay">立即支付</el-button>
        </el-col>
        <el-col :span="4" class="t3">
          <el-button @click="delOrderDialog=true">取消订单</el-button>
        </el-col>
      </el-row>
    </div>
    <div style="background-color:#fff;padding: 0 20px;">
      <div class="step" v-if="data.pay_type == '在线支付'">
        <el-steps :active="setp" align-center>
          <el-step
            title="提交订单"
            :description="dayjs.unix(data.create_time).format('YYYY-MM-DD HH:mm:ss')"
          ></el-step>
          <el-step
            title="付款成功"
            :description="data.pay_time==0?'':dayjs.unix(data.pay_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
          <el-step
            title="商品出库"
            :description="data.shipments_time==0?'':dayjs.unix(data.shipments_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
          <el-step
            title="确认收货"
            :description="data.sign_for_time==0?'':dayjs.unix(data.sign_for_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
          <el-step
            title="交易完成"
            :description="data.comment_time==0?'':dayjs.unix(data.comment_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
        </el-steps>
      </div>
      <div class="step" v-if="data.pay_type == '货到付款'">
        <el-steps :active="setp" align-center>
          <el-step
            title="提交订单"
            :description="dayjs.unix(data.create_time).format('YYYY-MM-DD HH:mm:ss')"
          ></el-step>
          <el-step
            title="商品出库"
            :description="data.shipments_time==0?'':dayjs.unix(data.shipments_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
          <el-step
            title="确认收货"
            :description="data.sign_for_time==0?'':dayjs.unix(data.sign_for_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
          <el-step
            title="交易完成"
            :description="data.comment_time==0?'':dayjs.unix(data.comment_time).format('YYYY-MM-DD HH:MM:ss')"
          ></el-step>
        </el-steps>
      </div>
      <div class="t1 lv2Text">商品信息</div>
      <div class="info">
        <div align="center">
          <el-table :data="infoArr" style="width: 100%" border :header-cell-style="tableHeader">
            <el-table-column label="商品信息">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="4" class="s1">
                    <router-link :to="'/product/'+scope.row.p_id">
                      <img :src="serve + '/'+scope.row.images" class="cover" />
                    </router-link>
                  </el-col>
                  <el-col :span="20" style="padding-top: 15px;">
                    <div class="link">
                      <router-link :to="'/product/'+scope.row.p_id">{{ scope.row.title }}</router-link>
                    </div>
                    <div class="item-no lv3Text">货号:{{ scope.row.item_no }}</div>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column align="center" label="单价" width="100">
              <template slot-scope="scope">&yen;{{scope.row.price}}</template>
            </el-table-column>
            <el-table-column align="center" prop="number" label="数量" width="100"></el-table-column>
            <el-table-column align="center" label="小计" width="100">
              <template slot-scope="scope">&yen;{{scope.row.total}}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="t1 lv2Text">收货信息</div>
      <div class="info2">
        <div class="row">
          <el-row>
            <el-col :span="2">收货人：</el-col>
            <el-col :span="22">{{addressArr[1]}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="2">手机号：</el-col>
            <el-col :span="22">{{addressArr[0]}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="2">收货地址：</el-col>
            <el-col
              :span="22"
            >{{addressArr[2]+" "+addressArr[3]+" "+addressArr[4]+" "+addressArr[5]}}</el-col>
          </el-row>
        </div>
      </div>

      <div class="t1 lv2Text">支付方式</div>
      <div class="info2">
        <div class="row">
          <el-row>
            <el-col :span="2">支付方式：</el-col>
            <el-col :span="22">{{data.pay_type}}</el-col>
          </el-row>
        </div>
      </div>

      <div class="t1 lv2Text">发票信息</div>
      <div class="info2">
        <div class="row lv3Text" v-if="data.invoice==null">未开发票</div>
        <div class="row lv2Text in" v-else>
          <div>{{data.invoice.type==1?'普通发票':'增值税发票'}}</div>
          <div v-if="data.invoice.type==1">
            <span class="lv3Text">发票抬头：</span>
            <span>{{data.invoice.type1==1?'个人':'单位 '+data.invoice.tax_number}}</span>
          </div>
          <div>
            <span class="lv3Text">名称:</span>
            <span>{{data.invoice.name}}</span>
          </div>
          <div>
            <span class="lv3Text">发票内容:</span>
            <span>{{data.invoice.content}}</span>
          </div>
          <div v-if="data.invoice.type==2">
            <span class="lv3Text">纳税人识别号:</span>
            <span>{{data.invoice.tax_number}}</span>
          </div>
          <div v-if="data.invoice.type==2">
            <span class="lv3Text">注册地址:</span>
            <span>{{data.invoice.register_address}}</span>
          </div>
          <div v-if="data.invoice.type==2">
            <span class="lv3Text">注册电话:</span>
            <span>{{data.invoice.register_phone}}</span>
          </div>
          <div v-if="data.invoice.type==2">
            <span class="lv3Text">开户银行:</span>
            <span>{{data.invoice.open_user_bank}}</span>
          </div>
          <div v-if="data.invoice.type==2">
            <span class="lv3Text">银行账户:</span>
            <span>{{data.invoice.open_card_number}}</span>
          </div>
          <div>
            <span class="lv3Text">收票人姓名:</span>
            <span>{{data.invoice.invoice_name}}</span>
          </div>
          <div>
            <span class="lv3Text">收票人电话:</span>
            <span>{{data.invoice.invoice_mobile}}</span>
          </div>
          <div>
            <span class="lv3Text">收票地址:</span>
            <span>{{data.invoice.address}}</span>
          </div>
        </div>
      </div>

      <div class="bottom">
        <el-row class="row">
          <el-col :span="2" :offset="19" class="title">商品件数：</el-col>
          <el-col :span="3" class="t">{{total}}件</el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" :offset="19" class="title">商品总价：</el-col>
          <el-col :span="3" class="t">&yen;{{data.all_money}}</el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" :offset="19" class="title">优惠：</el-col>
          <el-col :span="3" class="t">-&yen;{{data.coupons}}</el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" :offset="19" class="title">运费：</el-col>
          <el-col :span="3" class="t">&yen;{{data.express_money}}</el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" :offset="19" class="title">应付总额：</el-col>
          <el-col :span="3" class="t">&yen;{{data.pay_money}}</el-col>
        </el-row>
        <el-row class="submit" v-if="data.status==3">
          <el-col :span="3" :offset="21">
            <el-button type="primary" @click="finish(data.orderCode)">确认收货</el-button>
          </el-col>
        </el-row>
        <el-row class="submit" v-if="data.status==1">
          <el-col :span="3" :offset="21">
            <router-link :to="'/user/refund/1?order='+data.orderCode" >
              <el-button type="primary">申请退款</el-button>
            </router-link>
          </el-col>
        </el-row>
        <el-row class="submit" v-if="data.status>3">
          <el-col :span="3" :offset="21">
            <el-button type="primary" disabled>已完成</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="取消订单" :visible.sync="delOrderDialog" width="50%">
      <div>取消订单后，本单享有的优惠可能会一并取消，是否继续？</div>
      <div class="lv3Text" style="font-size:12px;margin-top: 10px;">请选择取消订单的原因（必选）：</div>
      <div class="reason">
        <el-row :gutter="20">
          <el-col :span="12">
            <button @click="delReason=1" :class="delReason==1?'active':''">配送信息有误</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=2" :class="delReason==2?'active':''">商品买错了</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=3" :class="delReason==3?'active':''">重复下单/误下单</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=4" :class="delReason==4?'active':''">忘记使用优惠券/积分等</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=5" :class="delReason==5?'active':''">其他渠道价格更低</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=6" :class="delReason==6?'active':''">不想买了</button>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delOrderDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="cancelOrder()"
          :loading="loading1"
          :disabled="delReason==null"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      loading1: false,
      delReason: 0,
      delOrderDialog: false,
      id: null,
      data: null,
      infoArr: null,
      addressArr: null,
      total: 0,
      time: null,
      setp: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },
  created() {
    this.initData();
  },
  activated() {
    this.$store.state.login_left = 0;
  },
  methods: {
    //
    initData() {
      this.id = this.$route.query.id;
      this.$store.state.user_location = "我的订单";
      this.$store.state.user_location2 = "订单详情";
      this.$store.state.login_left = 0;
      this.axios
        .get(this.serve + "/personal/order_info", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.id
          }
        })
        .then(res => {
          var that = this;
          setInterval(function() {
            var date1 = that.dayjs();
            var date2 = that.dayjs.unix(res.data.data.end_time);
            that.distance = date2.diff(date1);
            that.hours = Math.floor(
              (that.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            that.minutes = Math.floor(
              (that.distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            that.seconds = Math.floor((that.distance % (1000 * 60)) / 1000);
          }, 1000);

          this.data = res.data.data;
          var p = this.dayjs.unix(this.data.end_time).diff(this.dayjs());
          setInterval(() => {
            p -= 1000;
            this.time = this.getTime(p);
          }, 1000);

          this.total = 0;
          this.infoArr = JSON.parse(this.data.product_list);
          this.addressArr = this.data.address.split(";");
          for (var item of this.infoArr) {
            this.total += parseInt(item.number);
          }
          if (this.data.pay_type == "货到付款") {
            switch (this.data.status) {
              case "0":
                this.setp = 0;
                break;
              case "3":
                this.setp = 1;
                break;
              case "4":
                this.setp = 2;
                break;
              case "5":
                this.setp = 3;
                break;
            }
          } else if (this.data.pay_type == "在线支付") {
            switch (this.data.status) {
              case "0":
                this.setp = 0;
                break;
              case "1":
                this.setp = 1;
                break;
              case "2":
                this.setp = 1;
                break;
              case "3":
                this.setp = 2;
                break;
              case "4":
                this.setp = 3;
                break;
              case "5":
                this.setp = 4;
                break;
            }
          }
        });
    },
    cancelOrder() {
      this.loading1 = true;
      this.axios
        .get(this.serve + "/personal/cancel_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.id,
            cause: this.delReason
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loading1 = false;
            this.delOrderDialog = false;
            this.$message("订单已取消");
            this.initData();
          }
        });
    },
    goPay() {
      this.$router.push("/user/pay?order=" + this.data.orderCode);
    },
    finish(order) {
      this.axios
        .get(this.serve + "/personal/sign_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: order
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "收货成功"
            });
            this.initData();
          }
        });
    },
    tableHeader({ row, rowIndex }) {
      return {
        backgroundColor: "#eee",
        color: "#666",
        textAlign: "center"
      };
    },
    getTime(date) {
      var hours = date / 3600000;
      var minutes = (date % 3600000) / 60000;
      var seconds = (date % 60000) / 1000;
      return (
        parseInt(hours) + ":" + parseInt(minutes) + ":" + parseInt(seconds)
      );
    }
  }
};
</script>
<style lang="scss">
#viewOrder {
  .reason {
    padding: 20px 0;
  }
  .reason button {
    display: block;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    color: #666;
    line-height: 40px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .reason button.active {
    border: 1px solid #e2211c;
    color: #e2211c;
  }
  .in {
    line-height: 2em;
  }
  background-color: #fff;
  .t3 {
    padding-top: 25px;
    padding-left: 40px;
  }
  .t2 {
    padding-top: 25px;
    text-align: center;
    line-height: 2em;
  }
  .bottom {
    .submit {
      margin: 20px 0 40px 0;
    }
    .title {
      color: #666;
    }
    .t {
      color: #e2211c;
    }
    text-align: right;
    .row {
      padding-bottom: 10px;
    }
  }
  .s1 a {
    display: inline-block;
  }
  .link a {
    cursor: pointer;
    color: #606266;
  }
  .link a:hover {
    text-decoration: underline;
  }
  .info2 {
    border: 1px solid #ddd;
    padding: 20px;
    .row {
      margin-bottom: 10px;
    }
    margin-bottom: 20px;
  }
  .t1 {
    padding: 20px 0;
    font-size: 16px;
  }
  .item-no {
    font-size: 12px;
  }
  .cover {
    width: 70px;
    height: 70px;
    border: 1px solid #ddd;
  }
  .el-step.is-horizontal .el-step__line {
    top: 30px;
  }
  .el-step__icon {
    height: 60px;
    width: 60px;
  }
  .is-finish .el-step__icon {
    background-color: #e2211c;
    color: #fff;
  }
  .is-process .el-step__icon {
    background-color: #e2211c;
    color: #fff;
    border: 0;
  }
  .el-step__description.is-process,
  .el-step__title.is-process {
    color: #e2211c;
  }

  border: 1px solid #ddd;
  .wait {
    background-color: #eeeeee;
  }
  .step {
    background-color: #fff;
    padding: 30px 0;
  }
}
</style>